import { axiosInstance } from './axiosConfig';
import { handleRequestWithAuth } from './refreshService';

const API_URL_SERVICIOS = 'servicios/';
const API_URL_ESPACIOS = 'espacios/';
const API_URL_ACTIVOS = 'espacio-servicios-activos/';

export interface EspacioServicio {
    id: number;
    espacio: number;
    servicio: number;
    fecha_creacion: string;
    estado: boolean;
    espacio_nombre?: string;
}

export interface CatalogoItem {
    id: number;
    nombre: string;
    descripcion?: string;
    estado?: boolean;
    // Agrega otras propiedades según lo que devuelva tu API
}

export const fetchEspacios = async (): Promise<CatalogoItem[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL_ESPACIOS);
        return response.data;
    });
};

export const fetchServicios = async (): Promise<CatalogoItem[]> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(API_URL_SERVICIOS);
        return response.data;
    });
};

// Nueva función para obtener un solo servicio
export const fetchServicioById = async (id: number): Promise<CatalogoItem> => {
    return handleRequestWithAuth(async () => {
        const response = await axiosInstance.get(`${API_URL_SERVICIOS}${id}/`);
        return response.data;
    });
};

export const fetchEspacioServiciosActivos = async (servicioId?: number): Promise<EspacioServicio[]> => {
    return handleRequestWithAuth(async () => {
        const params = {
            estado: true,
            ...(servicioId && { servicio_id: servicioId.toString() })
        };
        
        const response = await axiosInstance.get<EspacioServicio[]>(API_URL_ACTIVOS, {
            params: params
        });
        return response.data;
    });
};